import { defineComponent as He, ref as b, provide as Oe, toRef as J, computed as w, watch as Me, watchEffect as De, h as t, Transition as $e, withDirectives as je, nextTick as _e } from "vue";
import Le from "./ghl-ui.es909.js";
import Ee from "./ghl-ui.es910.js";
import Ke from "./ghl-ui.es911.js";
import Ne from "./ghl-ui.es912.js";
import qe from "./ghl-ui.es913.js";
import { deriveDefaultValue as Ge, getModeFromValue as ce } from "./ghl-ui.es914.js";
import Je from "./ghl-ui.es915.js";
import Qe from "./ghl-ui.es916.js";
import { colorPickerInjectionKey as We } from "./ghl-ui.es917.js";
import Xe from "./ghl-ui.es918.js";
import Ye from "./ghl-ui.es870.js";
import Ze from "./ghl-ui.es919.js";
import eo from "./ghl-ui.es854.js";
import ge from "./ghl-ui.es855.js";
import de from "./ghl-ui.es712.js";
import { rgba as Q, hsla as W, hsva as X, toHexString as Y, toHexaString as Z, toRgbaString as ee, toRgbString as fe, toHslaString as oe, toHslString as he, toHsvaString as re, toHsvString as ve } from "./ghl-ui.es904.js";
import { rgb2hsv as oo, hsl2hsv as ro, hsl2rgb as lo, hsv2rgb as z, rgb2hsl as to, hsv2hsl as le } from "./ghl-ui.es920.js";
import { createKey as me } from "./ghl-ui.es384.js";
import { useThemeClass as ao } from "./ghl-ui.es857.js";
import no from "./ghl-ui.es713.js";
import { getPreciseEventTarget as so } from "./ghl-ui.es875.js";
import io from "./ghl-ui.es718.js";
import uo from "./ghl-ui.es921.js";
import { call as M } from "./ghl-ui.es876.js";
import D from "./ghl-ui.es253.js";
import { useAdjustedTo as te } from "./ghl-ui.es877.js";
import co from "./ghl-ui.es878.js";
import fo from "./ghl-ui.es879.js";
import ho from "./ghl-ui.es880.js";
const vo = Object.assign(Object.assign({}, ge.props), {
  value: String,
  show: {
    type: Boolean,
    default: void 0
  },
  defaultShow: Boolean,
  defaultValue: String,
  modes: {
    type: Array,
    // no hsva by default since browser doesn't support it
    default: () => ["rgb", "hex", "hsl"]
  },
  placement: {
    type: String,
    default: "bottom-start"
  },
  to: te.propTo,
  showAlpha: {
    type: Boolean,
    default: !0
  },
  showPreview: Boolean,
  swatches: Array,
  disabled: {
    type: Boolean,
    default: void 0
  },
  actions: {
    type: Array,
    default: null
  },
  internalActions: Array,
  size: String,
  renderLabel: Function,
  onComplete: Function,
  onConfirm: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array]
}), No = He({
  name: "ColorPicker",
  props: vo,
  setup(r, {
    slots: y
  }) {
    const P = b(null);
    let B = null;
    const $ = Ye(r), {
      mergedSizeRef: ae,
      mergedDisabledRef: pe
    } = $, {
      localeRef: I
    } = Ze("global"), {
      mergedClsPrefixRef: j,
      namespaceRef: be,
      inlineThemeDisabled: _
    } = eo(r), L = ge("ColorPicker", "-color-picker", Xe, uo, r, j);
    Oe(We, {
      themeRef: L,
      renderLabelRef: J(r, "renderLabel"),
      colorPickerSlots: y
    });
    const ne = b(r.defaultShow), se = de(J(r, "show"), ne);
    function H(e) {
      const {
        onUpdateShow: o,
        "onUpdate:show": a
      } = r;
      o && M(o, e), a && M(a, e), ne.value = e;
    }
    const {
      defaultValue: ie
    } = r, ue = b(ie === void 0 ? Ge(r.modes, r.showAlpha) : ie), c = de(J(r, "value"), ue), A = b([c.value]), g = b(0), E = w(() => ce(c.value)), {
      modes: we
    } = r, m = b(ce(c.value) || we[0] || "rgb");
    function ke() {
      const {
        modes: e
      } = r, {
        value: o
      } = m, a = e.findIndex((n) => n === o);
      ~a ? m.value = e[(a + 1) % e.length] : m.value = "rgb";
    }
    let f, h, V, U, k, C, S, v;
    const F = w(() => {
      const {
        value: e
      } = c;
      if (!e)
        return null;
      switch (E.value) {
        case "hsv":
          return X(e);
        case "hsl":
          return [f, h, V, v] = W(e), [...ro(f, h, V), v];
        case "rgb":
        case "hex":
          return [k, C, S, v] = Q(e), [...oo(k, C, S), v];
      }
    }), R = w(() => {
      const {
        value: e
      } = c;
      if (!e)
        return null;
      switch (E.value) {
        case "rgb":
        case "hex":
          return Q(e);
        case "hsv":
          return [f, h, U, v] = X(e), [...z(f, h, U), v];
        case "hsl":
          return [f, h, V, v] = W(e), [...lo(f, h, V), v];
      }
    }), K = w(() => {
      const {
        value: e
      } = c;
      if (!e)
        return null;
      switch (E.value) {
        case "hsl":
          return W(e);
        case "hsv":
          return [f, h, U, v] = X(e), [...le(f, h, U), v];
        case "rgb":
        case "hex":
          return [k, C, S, v] = Q(e), [...to(k, C, S), v];
      }
    }), Ce = w(() => {
      switch (m.value) {
        case "rgb":
        case "hex":
          return R.value;
        case "hsv":
          return F.value;
        case "hsl":
          return K.value;
      }
    }), O = b(0), N = b(1), q = b([0, 0]);
    function Se(e, o) {
      const {
        value: a
      } = F, n = O.value, s = a ? a[3] : 1;
      q.value = [e, o];
      const {
        showAlpha: l
      } = r;
      switch (m.value) {
        case "hsv":
          i((l ? re : ve)([n, e, o, s]), "cursor");
          break;
        case "hsl":
          i((l ? oe : he)([...le(n, e, o), s]), "cursor");
          break;
        case "rgb":
          i((l ? ee : fe)([...z(n, e, o), s]), "cursor");
          break;
        case "hex":
          i((l ? Z : Y)([...z(n, e, o), s]), "cursor");
          break;
      }
    }
    function Re(e) {
      O.value = e;
      const {
        value: o
      } = F;
      if (!o)
        return;
      const [, a, n, s] = o, {
        showAlpha: l
      } = r;
      switch (m.value) {
        case "hsv":
          i((l ? re : ve)([e, a, n, s]), "cursor");
          break;
        case "rgb":
          i((l ? ee : fe)([...z(e, a, n), s]), "cursor");
          break;
        case "hex":
          i((l ? Z : Y)([...z(e, a, n), s]), "cursor");
          break;
        case "hsl":
          i((l ? oe : he)([...le(e, a, n), s]), "cursor");
          break;
      }
    }
    function xe(e) {
      switch (m.value) {
        case "hsv":
          [f, h, U] = F.value, i(re([f, h, U, e]), "cursor");
          break;
        case "rgb":
          [k, C, S] = R.value, i(ee([k, C, S, e]), "cursor");
          break;
        case "hex":
          [k, C, S] = R.value, i(Z([k, C, S, e]), "cursor");
          break;
        case "hsl":
          [f, h, V] = K.value, i(oe([f, h, V, e]), "cursor");
          break;
      }
      N.value = e;
    }
    function i(e, o) {
      o === "cursor" ? B = e : B = null;
      const {
        nTriggerFormChange: a,
        nTriggerFormInput: n
      } = $, {
        onUpdateValue: s,
        "onUpdate:value": l
      } = r;
      s && M(s, e), l && M(l, e), a(), n(), ue.value = e;
    }
    function ye(e) {
      i(e, "input"), _e(T);
    }
    function T(e = !0) {
      const {
        value: o
      } = c;
      if (o) {
        const {
          nTriggerFormChange: a,
          nTriggerFormInput: n
        } = $, {
          onComplete: s
        } = r;
        s && s(o);
        const {
          value: l
        } = A, {
          value: d
        } = g;
        e && (l.splice(d + 1, l.length, o), g.value = d + 1), a(), n();
      }
    }
    function Pe() {
      const {
        value: e
      } = g;
      e - 1 < 0 || (i(A.value[e - 1], "input"), T(!1), g.value = e - 1);
    }
    function Ae() {
      const {
        value: e
      } = g;
      e < 0 || e + 1 >= A.value.length || (i(A.value[e + 1], "input"), T(!1), g.value = e + 1);
    }
    function Ve() {
      i(null, "input"), H(!1);
    }
    function Ue() {
      const {
        value: e
      } = c, {
        onConfirm: o
      } = r;
      o && o(e), H(!1);
    }
    const Te = w(() => g.value >= 1), Be = w(() => {
      const {
        value: e
      } = A;
      return e.length > 1 && g.value < e.length - 1;
    });
    Me(se, (e) => {
      e || (A.value = [c.value], g.value = 0);
    }), De(() => {
      if (!(B && B === c.value)) {
        const {
          value: e
        } = F;
        e && (O.value = e[0], N.value = e[3], q.value = [e[1], e[2]]);
      }
      B = null;
    });
    const G = w(() => {
      const {
        value: e
      } = ae, {
        common: {
          cubicBezierEaseInOut: o
        },
        self: {
          textColor: a,
          color: n,
          panelFontSize: s,
          boxShadow: l,
          border: d,
          borderRadius: u,
          dividerColor: x,
          [me("height", e)]: ze,
          [me("fontSize", e)]: Ie
        }
      } = L.value;
      return {
        "--n-bezier": o,
        "--n-text-color": a,
        "--n-color": n,
        "--n-panel-font-size": s,
        "--n-font-size": Ie,
        "--n-box-shadow": l,
        "--n-border": d,
        "--n-border-radius": u,
        "--n-height": ze,
        "--n-divider-color": x
      };
    }), p = _ ? ao("color-picker", w(() => ae.value[0]), G, r) : void 0;
    function Fe() {
      var e;
      const {
        value: o
      } = R, {
        value: a
      } = O, {
        internalActions: n,
        modes: s,
        actions: l
      } = r, {
        value: d
      } = L, {
        value: u
      } = j;
      return t("div", {
        class: [`${u}-color-picker-panel`, p == null ? void 0 : p.themeClass.value],
        onDragstart: (x) => {
          x.preventDefault();
        },
        style: _ ? void 0 : G.value
      }, t("div", {
        class: `${u}-color-picker-control`
      }, t(Ke, {
        clsPrefix: u,
        rgba: o,
        displayedHue: a,
        displayedSv: q.value,
        onUpdateSV: Se,
        onComplete: T
      }), t("div", {
        class: `${u}-color-picker-preview`
      }, t("div", {
        class: `${u}-color-picker-preview__sliders`
      }, t(Le, {
        clsPrefix: u,
        hue: a,
        onUpdateHue: Re,
        onComplete: T
      }), r.showAlpha ? t(Ee, {
        clsPrefix: u,
        rgba: o,
        alpha: N.value,
        onUpdateAlpha: xe,
        onComplete: T
      }) : null), r.showPreview ? t(Qe, {
        clsPrefix: u,
        mode: m.value,
        color: R.value && Y(R.value),
        onUpdateColor: (x) => {
          i(x, "input");
        }
      }) : null), t(Ne, {
        clsPrefix: u,
        showAlpha: r.showAlpha,
        mode: m.value,
        modes: s,
        onUpdateMode: ke,
        value: c.value,
        valueArr: Ce.value,
        onUpdateValue: ye
      }), ((e = r.swatches) === null || e === void 0 ? void 0 : e.length) && t(Je, {
        clsPrefix: u,
        mode: m.value,
        swatches: r.swatches,
        onUpdateColor: (x) => {
          i(x, "input");
        }
      })), l != null && l.length ? t("div", {
        class: `${u}-color-picker-action`
      }, l.includes("confirm") && t(D, {
        size: "small",
        onClick: Ue,
        theme: d.peers.Button,
        themeOverrides: d.peerOverrides.Button
      }, {
        default: () => I.value.confirm
      }), l.includes("clear") && t(D, {
        size: "small",
        onClick: Ve,
        disabled: !c.value,
        theme: d.peers.Button,
        themeOverrides: d.peerOverrides.Button
      }, {
        default: () => I.value.clear
      })) : null, y.action ? t("div", {
        class: `${u}-color-picker-action`
      }, {
        default: y.action
      }) : n ? t("div", {
        class: `${u}-color-picker-action`
      }, n.includes("undo") && t(D, {
        size: "small",
        onClick: Pe,
        disabled: !Te.value,
        theme: d.peers.Button,
        themeOverrides: d.peerOverrides.Button
      }, {
        default: () => I.value.undo
      }), n.includes("redo") && t(D, {
        size: "small",
        onClick: Ae,
        disabled: !Be.value,
        theme: d.peers.Button,
        themeOverrides: d.peerOverrides.Button
      }, {
        default: () => I.value.redo
      })) : null);
    }
    return {
      mergedClsPrefix: j,
      namespace: be,
      selfRef: P,
      hsla: K,
      rgba: R,
      mergedShow: se,
      mergedDisabled: pe,
      isMounted: no(),
      adjustedTo: te(r),
      mergedValue: c,
      handleTriggerClick() {
        H(!0);
      },
      handleClickOutside(e) {
        var o;
        !((o = P.value) === null || o === void 0) && o.contains(so(e)) || H(!1);
      },
      renderPanel: Fe,
      cssVars: _ ? void 0 : G,
      themeClass: p == null ? void 0 : p.themeClass,
      onRender: p == null ? void 0 : p.onRender
    };
  },
  render() {
    const {
      $slots: r,
      mergedClsPrefix: y,
      onRender: P
    } = this;
    return P == null || P(), t("div", {
      class: [this.themeClass, `${y}-color-picker`],
      ref: "selfRef",
      style: this.cssVars
    }, t(co, null, {
      default: () => [t(fo, null, {
        default: () => t(qe, {
          clsPrefix: y,
          value: this.mergedValue,
          hsla: this.hsla,
          disabled: this.mergedDisabled,
          onClick: this.handleTriggerClick
        }, {
          label: r.label
        })
      }), t(ho, {
        placement: this.placement,
        show: this.mergedShow,
        containerClass: this.namespace,
        teleportDisabled: this.adjustedTo === te.tdkey,
        to: this.adjustedTo
      }, {
        default: () => t($e, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted
        }, {
          default: () => this.mergedShow ? je(this.renderPanel(), [[io, this.handleClickOutside, void 0, {
            capture: !0
          }]]) : null
        })
      })]
    }));
  }
});
export {
  vo as colorPickerProps,
  No as default
};
